module.exports = __webpack_public_path__ + "img/del-icon.e3ebf50a.png";